import React from "react";
import { IAgentProductDetails } from "../../../../../../../../../../../../agentDetail.model";
import styles from "./accordionHeader.module.css";

export const AccordionHeader = ({ product }: { product: IAgentProductDetails }) => (
    <div className={styles.accordionHeader}>
        <div className={styles.detailsCtn}>
            <h4 className={styles.title}>{product.productName}</h4>
            <p className={styles.description}>
                {product.carrier && `Carrier: ${product.carrier}`}
                {product.carrier && product.productCommissionLevel && " | "}
                {product.productCommissionLevel &&
                    `Commission Level: ${product.productCommissionLevel}`}
            </p>
        </div>
        <div
            className={`${styles.badgeCtn} ${product.isApproved ? styles.approvedBadge : styles.disapprovedBadge}`}
        >
            <p className={styles.badgeText}>{product.isApproved ? "Approved" : "Not Approved"}</p>
        </div>
    </div>
);